(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/views/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/views/fractiongames-page.js');

'use strict';

svs.keno.views.FractiongamesPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'keno',
    component: 'fractiongames'
  }],
  template() {
    return svs.keno.templates.fractiongames_page();
  },
  onDomRefresh() {
    if (svs.keno.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.render(React.createElement(svs.keno.components.fractiongames.FractiongamesApp, null), target);
    }
  },
  onDestroy() {
    if (svs.keno.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.unmountComponentAtNode(target);
    }
  }
});

 })(window);